export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-m@2x.fc713d05.png";